export default class FormEventSubscription {
    constructor({ event, callback, field, module }) {
        this.event = event;
        this.callback = callback;
        this.field = field;
        this.module = module;

        this.init();
    }

    init() {
        if (!this.event) {
            throw new Error('FormEventSubscription: Event is not defined!');
        }

        if (!this.callback) {
            throw new Error('FormEventSubscription: Callback is not defined!');
        }
    }
}